import React from "react";
import PropTypes from "prop-types";
import styles from "./SpanInput.module.css";

import RadioButtonGroup from "../RadioButtonGroup";

/**
 * Interactive component. A select input of type "date," "time," "text," or "number."
 */
export function SpanInput({
  currentValue,
  setCurrentValue,
  inputType,
  inputLabel,
  labelStyle,
  placeholder,
  radioOptions,
}) {
  return (
    <div className={styles.container}>
      <label hidden htmlFor={inputLabel}>
        {inputLabel}
      </label>
      <span style={labelStyle} className={styles.label}>
        {inputLabel}
      </span>
      {inputType !== "radio" ? (
        <input
          className={styles.input}
          type={inputType}
          name={inputLabel}
          value={currentValue}
          onChange={setCurrentValue}
          placeholder={placeholder}
        />
      ) : (
        <RadioButtonGroup
          currentlySelected={currentValue}
          setCurrentlySelected={setCurrentValue}
          options={radioOptions}
        />
      )}
    </div>
  );
}

SpanInput.propTypes = {
  /**
   * The current value of the input.
   */
  currentValue: PropTypes.string,
  /**
   * Function that fires onChange and controls the value of "currentValue."
   */
  setCurrentValue: PropTypes.func,
  /**
   * Determines the type of input.
   */
  inputType: PropTypes.oneOf(["date", "time", "text", "number", "radio"]),
  /**
   * The label of the input.
   */
  inputLabel: PropTypes.string,
  /**
   * Optional extra styling for the input label.
   */
  labelStyle: PropTypes.object,
  /**
   * Optional input placeholder.
   */
  placeholder: PropTypes.string,
  /**
   * Optional array of radio options if inputType is "radio".
   */
  radioOptions: PropTypes.arrayOf(PropTypes.string),
};
